import enquiries from '../../api/enquiries';
import * as types from '../mutation-types';
import _ from 'lodash';

const state = {
  enquiryStatuses: []
};

const getters = {
  EnquiryStatuses: state => state.enquiryStatuses,
  StatusName: state => id => {
    let index = _.findIndex(state.enquiryStatuses, { id });
    return index > -1 ? state.enquiryStatuses[index].name : null;
  }
};

const actions = {
  getEnquiryStatusList: _.debounce(({ commit, state }) => {
    if (state.enquiryStatuses.length === 0) {
      enquiries.getEnquiryStatusList().then(response => {
        commit(types.SET_ENQUIRY_STATUS_LIST, response);
      });
    }
  }, 500)
};

const mutations = {
  [types.SET_ENQUIRY_STATUS_LIST](state, enquiryStatuses) {
    state.enquiryStatuses = enquiryStatuses.data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
